import { render, staticRenderFns } from "./Summarized.vue?vue&type=template&id=ae80199a&scoped=true&"
import script from "./Summarized.vue?vue&type=script&lang=js&"
export * from "./Summarized.vue?vue&type=script&lang=js&"
import style0 from "./Summarized.vue?vue&type=style&index=0&id=ae80199a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae80199a",
  null
  
)

export default component.exports